import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  close1s6qtnweux4fu as close,
  ObjectPool3iks1t8z0qq3m as ObjectPool,
} from './Pool.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultPoolClass;
function DefaultPool() {
  if (DefaultPoolClass === VOID) {
    class $ {
      constructor(capacity) {
        this.capacity_1 = capacity;
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.capacity_1;
        tmp.instances_1 = Array(size);
        this.size_1 = 0;
      }
      disposeInstance_6ek0a2_k$(instance) {
      }
      clearInstance_nfz4jw_k$(instance) {
        return instance;
      }
      validateInstance_6mwbhp_k$(instance) {
      }
      borrow_mvkpor_k$() {
        if (this.size_1 === 0)
          return this.produceInstance_xswihh_k$();
        this.size_1 = this.size_1 - 1 | 0;
        var idx = this.size_1;
        var tmp = this.instances_1[idx];
        var instance = !(tmp == null) ? tmp : THROW_CCE();
        this.instances_1[idx] = null;
        return this.clearInstance_nfz4jw_k$(instance);
      }
      recycle_d2xv5h_k$(instance) {
        this.validateInstance_6mwbhp_k$(instance);
        if (this.size_1 === this.capacity_1) {
          this.disposeInstance_6ek0a2_k$(instance);
        } else {
          var _unary__edvuaz = this.size_1;
          this.size_1 = _unary__edvuaz + 1 | 0;
          this.instances_1[_unary__edvuaz] = instance;
        }
      }
      dispose_3nnxhr_k$() {
        var inductionVariable = 0;
        var last = this.size_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = this.instances_1[i];
            var instance = !(tmp == null) ? tmp : THROW_CCE();
            this.instances_1[i] = null;
            this.disposeInstance_6ek0a2_k$(instance);
          }
           while (inductionVariable < last);
        this.size_1 = 0;
      }
    }
    protoOf($).close_yn9xrc_k$ = close;
    initMetadataForClass($, 'DefaultPool', VOID, VOID, [ObjectPool()]);
    DefaultPoolClass = $;
  }
  return DefaultPoolClass;
}
//region block: exports
export {
  DefaultPool as DefaultPool2gb1fm4epwgu9,
};
//endregion

//# sourceMappingURL=DefaultPool.mjs.map
